import React, { useEffect, useState } from "react";
import { db } from "../FirebaseAdd";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

export default function Try() {
  const usersCollectionRef = collection(db, "subscribe");
  const [subscribe, setSubscribe] = useState([]);
  const [newEmail, setNewEmail] = useState("");

  const createUser = async () => {
    await addDoc(usersCollectionRef, {
      email: newEmail,
    });
    window.location.reload(false);
  };

  const deleteSubscribe = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this email?"
    );
    if (confirmDelete) {
      const subscribeDoc = doc(db, "subscribe", id);
      await deleteDoc(subscribeDoc);
      window.location.reload(false);
    }
  };

  useEffect(() => {
    const getSubscribedEmails = async () => {
      const data = await getDocs(usersCollectionRef);
      setSubscribe(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getSubscribedEmails();
  }, []);

  const usersCollectionRef2 = collection(db, "contact");
  const [contact, setContact] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [comment, setComment] = useState("");

  const createUser2 = async () => {
    await addDoc(usersCollectionRef2, {
      name: name,
      email: email,
      phone: phone,
      subject: subject,
      comment: comment,
    });
    window.location.reload(false);
  };

  const deleteContact = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this contact?"
    );
    if (confirmDelete) {
      const contactDoc = doc(db, "contact", id);
      await deleteDoc(contactDoc);
      window.location.reload(false);
    }
  };

  //   const pushContact = async (id) => {
  //     const contactToPush = contact.find((user) => user.id === id);
  //     if (contactToPush) {
  //       const pushCollectionRef = collection(db, "pushed_contacts");
  //       await addDoc(pushCollectionRef, contactToPush);
  //       window.location.reload(false);
  //     }
  //   };

  useEffect(() => {
    const getContacts = async () => {
      const data = await getDocs(usersCollectionRef2);
      setContact(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getContacts();
  }, []);

  return (
    <div style={{ height: "1000px" }}>
      <div style={{ height: "100px" }} />
      <h1>Subscribed Emails</h1>

      <div>
        <input
          placeholder="Subscribe"
          onChange={(event) => {
            setNewEmail(event.target.value);
          }}
        />
        <button onClick={createUser}>Sent</button>
      </div>

      {subscribe.map((subscribedEmail) => {
        return (
          <div
            key={subscribedEmail.id}
            style={{
              border: "1px solid black",
              marginTop: "10px",
              display: "flex",
            }}
          >
            <p>Email: {subscribedEmail.email}</p>
            <button onClick={() => deleteSubscribe(subscribedEmail.id)}>
              Delete
            </button>
          </div>
        );
      })}
      <h1>Contact</h1>
      <div style={{ display: "flex", flexDirection: "column", margin: "20px" }}>
        <input
          placeholder="name"
          style={{ height: "40px" }}
          onChange={(event) => setName(event.target.value)}
        />
        <input
          placeholder="phone"
          style={{ height: "40px" }}
          onChange={(event) => setPhone(event.target.value)}
        />
        <input
          placeholder="email"
          style={{ height: "40px" }}
          onChange={(event) => setEmail(event.target.value)}
        />
        <input
          placeholder="subject"
          style={{ height: "40px" }}
          onChange={(event) => setSubject(event.target.value)}
        />
        <input
          placeholder="comment"
          style={{ height: "40px" }}
          onChange={(event) => setComment(event.target.value)}
        />
        <button style={{ height: "40px" }} onClick={createUser2}>
          Submit Contact
        </button>
      </div>

      {contact.map((user) => {
        return (
          <div
            key={user.id}
            style={{
              border: "1px solid black",
              marginTop: "10px",
              display: "flex",
            }}
          >
            <p>name: {user.name}</p>
            <div
              style={{ height: "50px", width: "2px", backgroundColor: "aqua" }}
            />
            <p>email:{user.email}</p>
            <div
              style={{ height: "50px", width: "2px", backgroundColor: "aqua" }}
            />
            <p>phone: {user.phone}</p>
            <div
              style={{ height: "50px", width: "2px", backgroundColor: "aqua" }}
            />
            <p>subject: {user.subject}</p>
            <div
              style={{ height: "50px", width: "2px", backgroundColor: "aqua" }}
            />
            <p>comment: {user.comment}</p>
            <button onClick={() => deleteContact(user.id)}>Delete</button>
          </div>
        );
      })}
    </div>
  );
}
